import apiClient from "../api/client";

export interface EnvironmentResponse {
  environment: string;
}

export async function getEnvironment(): Promise<EnvironmentResponse> {
  const response = await apiClient.get<EnvironmentResponse>(
    "/api/home/environment"
  );
  return response.data;
}